import { useField } from "formik";
import { FieldForm } from "components/RFQ/Input";
import { cn } from "utils/helpers";
import { BidderQuestionnaireHeader } from "./BidderQuestionnaireHeader";
import { useOptions } from "../hooks/useOptions";
export const SingleChoiceQuestionnaire = ({
	className,
	description,
	question,
	options,
	required,
	fieldValue,
	isClientPreview = false,
	previewQuestion = null,
	...props
}) => {
	const [, { error }] = useField(props);

	const radioOptions = useOptions({
		isClientPreview,
		fieldValue,
		previewQuestion,
	});

	return (
		<div
			className={cn(className)}
			{...props}
		>
			<BidderQuestionnaireHeader
				question={question}
				required={required}
				error={error}
				touchedField={props?.touchedField}
				description={props?.rfqSubmission ? "Select one option only" : null}
			/>
			<div>
				<FieldForm
					type="radio"
					className="my-4 w-full"
					options={radioOptions}
					name={props?.name || "questionnaire"}
					border
					disabled={props?.disabled}
				/>
			</div>
		</div>
	);
};
